// Otevření panelu asistenta odkudkoli (pole hledání v hlavičce, centrum asistenta, obrazovky): globální úložiště bez
// providera (useSyncExternalStore) jako kontext obrazovky — shell se kvůli panelu nemusí měnit. Požadavek může nést
// dotaz k odeslání nebo konverzaci k otevření; panel ho vyřídí v efektu (ne při renderu).
import { useSyncExternalStore } from 'react';

export interface PozadavekPanelu {
  /** Pořadové číslo — panel vyřizuje každý požadavek jednou. */
  cislo: number;
  /** Dotaz, který se má rovnou odeslat. */
  dotaz?: string;
  /** Konverzace, která se má otevřít (centrum asistenta → Dotazy). */
  konverzaceId?: string;
  /** U `dotaz`: začít novou konverzaci (pole hledání v hlavičce), ne pokračovat v rozepsané. */
  nova?: boolean;
  /**
   * U `dotaz`: pokračovat v poslední konverzaci (05/2202) — v té, která je v panelu otevřená, a když žádná není
   * (panel se právě otevřel), v nejnovější z Asistent › Dotazy; bez žádné konverzace začne nová.
   */
  pokracovat?: boolean;
}

export interface StavPanelu {
  otevreny: boolean;
  pozadavek: PozadavekPanelu | null;
}

let stav: StavPanelu = { otevreny: false, pozadavek: null };
let dalsiCislo = 1;
const posluchaci = new Set<() => void>();

function zmenit(novy: StavPanelu) {
  stav = novy;
  posluchaci.forEach((posluchac) => posluchac());
}

function prihlasit(posluchac: () => void) {
  posluchaci.add(posluchac);
  return () => {
    posluchaci.delete(posluchac);
  };
}

const aktualni = () => stav;

/**
 * Otevře panel; s `dotaz` ho rovnou odešle (s `nova` jako první dotaz nové konverzace, s `pokracovat` jako další dotaz
 * poslední konverzace), s `konverzaceId` otevře uloženou konverzaci.
 */
export function otevritAsistenta(
  moznosti: { dotaz?: string; konverzaceId?: string; nova?: boolean; pokracovat?: boolean } = {},
) {
  const maPozadavek = moznosti.dotaz !== undefined || moznosti.konverzaceId !== undefined;
  zmenit({
    otevreny: true,
    pozadavek: maPozadavek ? { cislo: dalsiCislo++, ...moznosti } : stav.pozadavek,
  });
}

export function zavritAsistenta() {
  if (stav.otevreny) zmenit({ ...stav, otevreny: false });
}

export function usePanelAsistenta(): StavPanelu {
  return useSyncExternalStore(prihlasit, aktualni, aktualni);
}

/** Pro testy: zavřený panel bez požadavků. */
export function vycistitPanelAsistenta() {
  zmenit({ otevreny: false, pozadavek: null });
}
